import React, { useEffect, useState } from "react";
import { Empty, message, Modal, Tabs, Avatar, Input, Button, Divider } from "antd";
import { ToolOutlined, CheckOutlined } from "@ant-design/icons";
import { getFileUrl } from "../../api/file";

import EquipmentForm from "./EquipmentForm";

import { getEquipments } from "../../api/equipment";
import { updateProject } from "../../api/project";

const { Search } = Input

export default function SearchAndCreateEquipmentModal({
  isModalOpen,
  handleOk,
  handleCancel,
  project,
  afterClose
}) {
  const [equipments, setEquipments] = useState(null);
  const [formInstance, setFormInstance] = useState();
  const [searchQuery, setSearchQuery] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);

  const addEquipmentToProject = async (equipment) => {
    const res = await updateProject({
      ...project,
      projectEquipments: [{
        isActive: 1,
        equipment: {
          id: equipment.id
        },
        project: {
          id: project.id
        },
      }],
    }).then((res) => {
      handleCancel();
      message.success("Equipment added successfully");
    })

  }

  const fetchEquipments =
    async ({ page, perPage, q }) => {
      try {
        const { results } = await getEquipments({ page, perPage, q })
        setEquipments(results);
      } catch (error) {
        console.error(error);
        message.error("Something went wrong");
      }
    }

  useEffect(() => {
    fetchEquipments({ page, perPage, q: searchQuery });
  }, [isModalOpen, page, perPage, searchQuery])

  const items = [
    {
      key: '1',
      label: "Add Available Equipment to Project",
      children: <div>
        <Search placeholder="Type to search available Equipments..."
          allowClear onSearch={(value) => setSearchQuery(value)}
        />

        <ul className="my-4">
          {
            equipments && equipments.length > 0 ? equipments.map((equipment) => {
              const match = project.projectEquipments.some(pEquipment => pEquipment.equipment.id === equipment.id && pEquipment.isActive)
              return (
                <li key={equipment.id} >
                  <div className="flex items-center justify-between w-full py-2 border-b" >
                    <div className="flex items-center">
                      <Avatar
                        src={equipment?.avatars?.length
                          ? getFileUrl(equipment.avatars[0])
                          : undefined}
                        size={45}
                        icon={<ToolOutlined />}
                      />
                      <div className="ml-4">
                        <p className="text-[14px] leading-[22px] font-normal">{equipment.name}</p>
                        <p className="text-[14px] leading-[22px] font-normal opacity-45">{equipment.nickName}</p>
                      </div>

                    </div>
                    <Button type="link" disabled={match} onClick={() => addEquipmentToProject(equipment)}>
                      {!match ? "Add to Project" : <div> <CheckOutlined className="text-green-500" />  Added to Project</div>}
                    </Button>
                  </div>
                  <Divider className="m-0 p-0" />
                </li>
              )
            }) : <Empty className="my-8" />
          }

        </ul>
      </div>,
    },
    {
      key: '2',
      label: "Create New Eqipment",
      children: <EquipmentForm onFormInstanceReady={(instance) => setFormInstance(instance)} />,
    }
  ]

  return (
    <Modal
      title="Add Equipment to Project"
      open={isModalOpen}
      onCancel={handleCancel}
      afterClose={afterClose}
      okText="Save"
      onOk={async () => {
        try {
          const values = await formInstance?.validateFields();
          formInstance?.resetFields();
          handleOk(values);
        } catch (error) {
          console.log('Failed:', error);
        }
      }}
    >
      <Tabs
        defaultActiveKey="1"
        items={items}
      />
    </Modal>
  )
}
